<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">免税品离岛提货跟踪服务系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          免税品离岛提货跟踪服务系统服务海南自由贸易港离岛免税购物场景，对接免税经营主体与机场、码头、火车站提货点，打通免税销售系统、海关联网监管系统与离岛交通票务数据，实现“线上预订—资格核验—海关验放—预约提货—扫码签收”全流程数字化闭环。
        </p>
        <p class="content-paragraph">
          平台面向旅客提供免税额度查询、离岛信息核验、提货点预约、提货码出示与退货改签线上办理；面向提货点提供预约排班、叫号排队、仓位管理与异常处置；面向监管部门提供订单联网报送、三单对账、风险预警与统计分析，在保障监管合规的前提下提升旅客提货效率与免税经营协同水平。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">资格核验</h3>
            <ul class="capability-list"><li>离岛信息核验</li><li>证件识别</li><li>免税额度</li><li>限购校验</li><li>订单同步</li><li>风险名单</li><li>异常拦截</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">预约提货</h3>
            <ul class="capability-list"><li>提货点预约</li><li>时段排班</li><li>叫号排队</li><li>仓位分配</li><li>扫码签收</li><li>退货改签</li><li>滞留处置</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">监管对账</h3>
            <ul class="capability-list"><li>海关联网</li><li>数据报送</li><li>三单对账</li><li>风险预警</li><li>退货监管</li><li>统计报表</li><li>审计追溯</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ms-app.svg"
              alt="海南华德科技有限公司 免税品离岛提货跟踪服务系统 - 旅客端 · 提货预约与提货码"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>旅客端 · 提货预约与提货码
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ms-workbench.svg"
              alt="海南华德科技有限公司 免税品离岛提货跟踪服务系统 - 提货作业 · 叫号排队与仓位管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>提货作业 · 叫号排队与仓位管理
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ms-screen.svg"
              alt="海南华德科技有限公司 免税品离岛提货跟踪服务系统 - 运行监测 · 提货点客流与效能"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>运行监测 · 提货点客流与效能
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ms-admin.svg"
              alt="海南华德科技有限公司 免税品离岛提货跟踪服务系统 - 监管对账 · 订单报送与海关验放"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>监管对账 · 订单报送与海关验放
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs15.vue